export function getDomain(url) {
  return url.replace(/^https?:\/\//i, "");
}

export function getHostName(url) {
  return new URL(url).hostname;
}
